// GET /pharm-dashboard/ad-campaigns item → 외부 프로모션 카드·상세 값 (순수 함수)
// API 에 없는 값(노출·사용·노출 대상·판매 단가)은 '-' — 정산 서버 작업 대기 (백엔드 회신 10/22)

const NA = '-';
const DAY = 86400000;

// 'YYYY-MM-DD' → 로컬 자정 기준 일수 차이 (b - a)
const days = (a, b) => {
  const [ay, am, ad] = a.split('-').map(Number);
  const [by, bm, bd] = b.split('-').map(Number);
  return Math.round((Date.UTC(by, bm - 1, bd) - Date.UTC(ay, am - 1, ad)) / DAY);
};
const md = d => d.slice(5).replace('-', '.');

export const discountLabel = c => {
  const won = n => `${Number(n || 0).toLocaleString()}원`;
  if (c.discount_type === 'BUY_N_GET_M') return `${c.buy_qty}+${c.free_qty} 증정`;
  if (c.discount_type === 'BUNDLE') return `함께 사면 ${won(c.amount)} 할인`;
  if (c.discount_type === 'PERCENT') return `${c.amount}% 할인`;
  if (c.discount_type === 'FIXED') return `${won(c.amount)} 할인`;
  return NA;
};

// 상품별 재고 판정(my_stock_status, 최근 60일 이 약국 판매 이력) → 캠페인 하나의 재고 표시
// 한 상품이라도 판매 중이면 보유, 전부 미판매면 미취급, 판매 기록 자체가 없으면(null) 모름
export const stockOf = c => {
  const list = [...(c.products || []), ...(c.bundle_items || [])];
  const qty = list.reduce((n, p) => n + (Number(p.my_sales_qty_30d) || 0), 0);
  if (list.some(p => p.my_stock_status === 'in_stock')) return { status: 'in_stock', qty };
  if (list.length && list.every(p => p.my_stock_status === 'not_handled')) return { status: 'not_handled', qty: 0 };
  return { status: null, qty: 0 };
};

export const toCampaign = (c, today) => {
  const total = days(c.start_date, c.end_date) + 1;
  const elapsed = Math.min(Math.max(days(c.start_date, today), 0), total);
  const toEnd = days(today, c.end_date);
  const toStart = days(today, c.start_date);
  const urgent = c.status === 'ACTIVE' && toEnd <= 3;
  const discount = discountLabel(c);
  const stock = stockOf(c);
  const inStock = stock.status === 'in_stock';
  return {
    id: c.campaign_id,
    joined: !!c.joined,
    company: c.company_name,
    title: c.coupon_name,
    desc: c.patient_notice || '',
    period: `${c.start_date.replace(/-/g, '.')} ~ ${md(c.end_date)}`,
    elapsed: `${elapsed}일 경과`,
    progress: Math.round((elapsed / total) * 100),
    deadline: urgent ? `마감 D-${toEnd}` : null,
    tag: `진행중 · D-${toEnd}${urgent ? ' 마감 임박' : ''}`,
    dday: `D-${toStart}`,
    duration: `${total}일간`,
    exposure: NA, target: '', used: NA, rate: '',
    notHandled: stock.status === 'not_handled',
    stock: inStock ? '보유' : NA,
    turn: inStock ? `월 회전 ${stock.qty}건` : '',
    product: (c.products || []).map(p => p.name).join(', ') || NA,
    stockLine: inStock ? `보유 · 월 회전 ${stock.qty}건` : stock.status === 'not_handled' ? '미취급' : NA,
    price: NA,
    // 거래없음 = 미취급과 같은 기준 (백엔드 10/22). 미결정/참여 취소 구분은 정산 서버 작업 대기
    reason: stock.status === 'not_handled' ? '거래없음' : NA,
    benefit: discount,
    guide: c.pharmacist_guide || NA,
    info: { period: `${md(c.start_date)} ~ ${md(c.end_date)} ${c.status === 'ACTIVE' ? `(D-${toEnd})` : '(예정)'}`, discount, target: NA },
  };
};

// 진행 중 탭 = 진행 중이고 참여한 캠페인, 신규 캠페인 검토 탭 = 시작 예정 (Figma "아래 쿠폰들은 시작 예정입니다")
// shortcut: 진행 중인데 미참여인 캠페인은 Figma 에 놓일 곳이 없어 표시 안 함 — 기획 결정 후 반영
export const splitCampaigns = (items, today) => {
  // 기간이 없는 캠페인은 D-day·진행률을 못 그리므로 제외 (명세상 필수 값)
  const list = (items ?? []).filter(c => c?.start_date && c?.end_date).map(c => ({ status: c.status, c: toCampaign(c, today) }));
  const active = list.filter(x => x.status === 'ACTIVE' && x.c.joined).map(x => x.c);
  const review = list.filter(x => x.status === 'SCHEDULED').map(x => x.c);
  return { active, review, pendingReview: review.filter(c => !c.joined).length };
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
